import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import AuthCallback from "./pages/AuthCallback";
import OAuthConsentPage from "./pages/OAuthConsentPage";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import UpdatePasswordPage from "./pages/UpdatePasswordPage";
import Dashboard from "./pages/Dashboard";
import LinksPage from "./pages/LinksPage";
import LinkDetailPage from "./pages/LinkDetailPage";
import SettingsPage from "./pages/SettingsPage";
import DomainsPage from "./pages/DomainsPage";
import EventsPage from "./pages/EventsPage";
import FoldersPage from "./pages/FoldersPage";
import TagsPage from "./pages/TagsPage";
import UTMTemplatesPage from "./pages/UTMTemplatesPage";
import WorkspaceName from "./pages/Onboarding/WorkspaceName";
import ClaimSubdomain from "./pages/Onboarding/ClaimSubdomain";
import WorkspaceReady from "./pages/Onboarding/WorkspaceReady";
import DocsPage from "./pages/DocsPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import ABTestsPage from "./pages/ABTestsPage";
import QRPage from "./pages/QRPage";
import AdminGuard from "./components/AdminGuard";
import AdminLayout from "./components/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminWorkspaces from "./pages/admin/AdminWorkspaces";
import AdminLinks from "./pages/admin/AdminLinks";
import AdminSettings from "./pages/admin/AdminSettings";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/reset-password" element={<UpdatePasswordPage />} />
      <Route path="/oauth/consent" element={<OAuthConsentPage />} />

      {/* Onboarding wizard (no AppLayout — full-page) */}
      <Route path="/onboarding" element={<ProtectedRoute><WorkspaceName /></ProtectedRoute>} />
      <Route path="/onboarding/subdomain" element={<ProtectedRoute><ClaimSubdomain /></ProtectedRoute>} />
      <Route path="/onboarding/ready" element={<ProtectedRoute><WorkspaceReady /></ProtectedRoute>} />

      {/* Main app */}
      <Route path="/dashboard" element={
        <ProtectedRoute><AppLayout><Dashboard /></AppLayout></ProtectedRoute>
      } />
      <Route path="/links" element={
        <ProtectedRoute><AppLayout><LinksPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/links/:linkId" element={
        <ProtectedRoute><AppLayout><LinkDetailPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/domains" element={
        <ProtectedRoute><AppLayout><DomainsPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/analytics" element={
        <ProtectedRoute><AppLayout><AnalyticsPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/events" element={
        <ProtectedRoute><AppLayout><EventsPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/ab-tests" element={
        <ProtectedRoute><AppLayout><ABTestsPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/folders" element={
        <ProtectedRoute><AppLayout><FoldersPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/tags" element={
        <ProtectedRoute><AppLayout><TagsPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/qr" element={
        <ProtectedRoute><AppLayout><QRPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/utm-templates" element={
        <ProtectedRoute><AppLayout><UTMTemplatesPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute><AppLayout><SettingsPage /></AppLayout></ProtectedRoute>
      } />
      <Route path="/docs" element={<DocsPage />} />
      <Route path="/admin" element={
        <ProtectedRoute><AdminGuard><AdminLayout><AdminDashboard /></AdminLayout></AdminGuard></ProtectedRoute>
      } />
      <Route path="/admin/users" element={
        <ProtectedRoute><AdminGuard><AdminLayout><AdminUsers /></AdminLayout></AdminGuard></ProtectedRoute>
      } />
      <Route path="/admin/workspaces" element={
        <ProtectedRoute><AdminGuard><AdminLayout><AdminWorkspaces /></AdminLayout></AdminGuard></ProtectedRoute>
      } />
      <Route path="/admin/links" element={
        <ProtectedRoute><AdminGuard><AdminLayout><AdminLinks /></AdminLayout></AdminGuard></ProtectedRoute>
      } />
      <Route path="/admin/settings" element={
        <ProtectedRoute><AdminGuard><AdminLayout><AdminSettings /></AdminLayout></AdminGuard></ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              fontFamily: "'Inter', sans-serif",
              borderRadius: '12px',
              border: '1px solid hsl(var(--border))',
              background: 'hsl(var(--card))',
              color: 'hsl(var(--foreground))',
              boxShadow: '0 20px 40px rgba(70, 72, 212, 0.08)',
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
